import dayjs from "dayjs";

export const formatDate = (dateString: string, locale: string): string =>
  dayjs(dateString).locale(locale).format("DD.MM.YYYY");

export function formatDateRange(startDate: string, endDate: string, locale: string): string | null {
  if (startDate === endDate) {
    return null;
  }

  return `(${formatDate(startDate, locale)} – ${formatDate(endDate, locale)})`;
}

export function formatComparisonRange(range: { startDate: string; endDate: string }, locale: string): string {
  if (range.startDate === range.endDate) {
    return formatDate(range.startDate, locale);
  }

  return `${formatDate(range.startDate, locale)} – ${formatDate(range.endDate, locale)}`;
}
